import { registerConsoleFunction } from '@/lib/console-functions';
import {
  deleteUISetting,
  fetchAllUISettings,
  UI_SETTINGS_CONTEXT,
  UISettingScope,
} from '@/lib/ui-settings';

/**
 * Forgets every tour the user has finished, in local storage and UI settings,
 * then reloads so they show again.
 */
async function clearFinishedTours() {
  console.info('clearing...');
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith('tour-')) localStorage.removeItem(key);
  }

  const presets = await fetchAllUISettings({ scope: UISettingScope.PRIVATE });
  await Promise.all(
    presets
      .filter((preset) => preset.key.startsWith(`${UI_SETTINGS_CONTEXT}.tour.`))
      .map((preset) =>
        deleteUISetting({ scope: UISettingScope.PRIVATE, key: preset.key })
      )
  );

  location.reload();
}

registerConsoleFunction('clearFinishedTours', clearFinishedTours);
